
import React, { Component } from "react";

import { Spin } from 'antd';

import WidgetPagination from './WidgetPagination';

import '../css/widget/widget.list.table.css';

class WidgetListTable extends Component {

    constructor (props) 
    {
        super(props);

        this.state = {
            pageSize: props.pageSize || 10,
            type:props.type
        }
    }

    componentWillReceiveProps( nextProps )
    {
        this.setState({pageSize:nextProps.pageSize});
    }

    changeType = ( type ) => {

        this.setState({type:type});
    }

    notify = ( item, type) => {

        if( this.props.notify )
        {
            this.props.notify(type, item);
        }
    }

    pageChange = (page, pageSize) => {

        this.setState({page:page, pageSize:pageSize});

        if( this.props.pageTurning )
        {
            this.props.pageTurning(page, pageSize);
        }
    }

    render() 
    {
        const { pageSize, type="single" } = this.state;

        const {data=[], page=1, total=0, loading=true } = this.props;

        return (
            <div className="sf-list-table sd-list-table sg-list-table">
                <div className="sf-list-table-tab sd-list-table-tab sg-list-table-tab">
                {
                    type!=="biserial" 
                        ? <>
                            <img onClick={() => { this.changeType("biserial")}} src={require('./../img/widget/biserial.png')} alt=""></img>

                            <img onClick={() => { this.changeType("single")}} src={require('./../img/widget/single-select.png')} alt=""></img>
                        </>
                        : <>
                            <img onClick={() => { this.changeType("biserial")}} src={require('./../img/widget/biserial-select.png')} alt=""></img>

                            <img onClick={() => { this.changeType("single")}} src={require('./../img/widget/single.png')} alt=""></img>
                        </>
                }
                </div>

                <div className={ type!=="biserial" ? "sf-list-table-content-single" : "sf-list-table-content-biserial" }>
                {
                    loading ? 
                    <>
                        <Spin />;
                    </>
                    :
                    <>
                    {
                        data.map((item, index) => {
                            return (
                                <div key={item.id + index} className="sf-list-table-item" onClick={ () => { this.notify(item, "click") }}>
                                    {
                                        item.hot ? <img className="sf-hot" src={require('./../img/widget/hot.png')} alt="" /> : <></> 
                                        
                                    }
                                    <div className="sf-list-table-item-icon">
                                        <img src={require('./../img/pinzhunzhun/career/' + item.imgPath)} alt=""></img>
                                    </div>
                                    <div className="sf-list-table-item-right">
                                        <div className="sf-list-table-item-title">{item.title}</div>
                                        <div className="sf-list-table-item-description">{item.description}</div>
                                        <div className="sf-list-table-item-operation">
                                            <div className="sf-list-table-item-operation-item">
                                                <img src={require('./../img/widget/bookmark.png')} alt="" />
                                                <span>{item.bookmarks}</span>
                                            </div>
                                            <div className="sf-list-table-item-operation-item">
                                                <img src={require('./../img/widget/thumb-up.png')} alt="" />
                                                <span>{item.thumbUps}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    </>
                }
                
                </div>

                <div className="sf-list-table-page">
                    <WidgetPagination 
                        page={page} 
                        total={total} 
                        pageSize={pageSize}
                        pageSizeOptions={[10, 20, 50, 100]}
                        pageChange={this.pageChange} 
                    />
                </div>
            </div>
        )
    }
}

export default WidgetListTable;